import { Grid } from 'theme-ui';
import { UseLocation } from 'Common/hooks/useLocation';
import ServiceAreaSelect from 'Common/components/ServiceAreaSelect';

export type StartDateTimeStageProps = {
  location: Pick<UseLocation, 'uid' | 'type'>;
  serviceAreaUid?: string | null | undefined;
  onServiceAreaSelect?: (newServiceAreaUid: string) => void;
  serviceProviderAvailabilityNode: React.ReactNode;
};

const StartDateTimeStage: React.FC<
  StartDateTimeStageProps
> = ({
  location,
  serviceAreaUid,
  onServiceAreaSelect,
  serviceProviderAvailabilityNode,
}) => {

  return (
    <div
      className="flex flex-col justify-between h-full w-full"
    >
      <div
        className="flex flex-wrap w-full gap-y-4"
      >
        <Grid className="gap-y-8 w-full" variant="leftFiveColumn">
          {serviceProviderAvailabilityNode}
          <ServiceAreaSelect
            location={location}
            value={serviceAreaUid}
            onSelect={s => onServiceAreaSelect && onServiceAreaSelect(s)}
            label="Meeting Instructions"
            disabled={Boolean(serviceAreaUid)}
          />
        </Grid>
      </div>
    </div>
  );
};

export default StartDateTimeStage;
